module.exports = __webpack_public_path__ + "img/wenlvIndex.b7ac6e14.png";